import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { useInjectReducer, useInjectSaga } from 'utils/redux-injectors';
import { goalSaga } from './saga';
import { GoalState } from './types';
import { Data } from 'app/pages/Yourplan/getGoals/types';

export const initialState: GoalState = {
  isLoading: false,
  createGoalSuccessResponse: null,
  createGoalFailureResponse: null,
  getGoalDataSuccessResponse: null,
  getGoalDataFailureResponse: null,
};

const slice = createSlice({
  name: 'goal',
  initialState,
  reducers: {
    createGoal(state, action: PayloadAction<any>) {
      state.isLoading = true;
      state.createGoalFailureResponse = null; // Reset on new submission
    },
    createGoalSuccess(state, action: PayloadAction<Data>) {
      state.isLoading = false;
      state.createGoalSuccessResponse = action.payload;
    },
    creatGoalFailure(state, action: PayloadAction<string>) {
      state.isLoading = false;
      state.createGoalFailureResponse = action.payload;
    },
    responsenull(state) {
      state.createGoalSuccessResponse = null;
    },
    getGoalData(state, actions: PayloadAction<any>) {
      state.isLoading = true;
    },
    getGoalDataSuccess(state, action: PayloadAction<any>) {
      state.isLoading = false;
      state.getGoalDataSuccessResponse = action.payload;
    },
    getGoalDataFailure(state, action: PayloadAction<any>) {
      state.isLoading = false;
      state.getGoalDataFailureResponse = action.payload;
    },
    getGoalDataReset(state) {
      state.getGoalDataFailureResponse = null;
      state.getGoalDataSuccessResponse = null;
    },
  },
});

export const { actions: goalActions } = slice;

export const useGoalSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectSaga({ key: slice.name, saga: goalSaga });
  return { actions: slice.actions };
};

/**
 * Example Usage:
 *
 * export function MyComponentNeedingThisSlice() {
 *  const { actions } = useGoalSlice();
 *
 *  const onButtonClick = (evt) => {
 *    dispatch(actions.someAction());
 *   };
 * }
 */
